import React from "react";
import "./AssetThumbnail.scss";

const AssetThumbnail = ({ thumbnailUrl = null }) => {
    return (
        <div className={"tvp-thumbnail-container"}>
            <div className={"photo-background"}>
                <div
                    style={{
                        backgroundImage: `url(${thumbnailUrl})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        height: "100%",
                        width: "100%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                ></div>
            </div>
        </div>
    );
};

export default AssetThumbnail;
